import React , { useEffect , useState } from 'react';
import { Card, CardBody, Button, Input, Col, Container, Row, ListGroup, ListGroupItem, Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import Bot from '../../assets/images/bot.png';
import User from '../../assets/images/account.png';
import Bot_In_Group from './Bot_In_Group';
import Users_In_Group from './Users_In_Group';
import Token_Balane from './Token_Balane';
import Token_Usage from './Token_Usage';
import Upgrade_Plans from './Upgrade_Plans';
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { fetch_group_token_usages, GET_DB_Connection, Get_Favourite_Prompt_Category, group_owner_details, leave_group } from '../../slices/thunks';
import { Loader } from 'feather-icons-react/build/IconComponents';
import { close_confirm_modal, open_confirm_modal } from '../../slices/Confirm_Modal/reducer';
import { waitForDecision } from '../../utility/wait_for_confirmation';
import Update_Group_Details from '../../Components/Common/CustomModal/Update_Group_Details';
import Database_In_Group from './Database_In_Group';
import { Token_Usage_Chart } from './Group_Chart';
import { getTokenUsedMonthwise } from '../../helpers/fakebackend_helper';
import { get_DB_connections } from '../../helpers/url_helper';
import { set_bread_crum } from '../../slices/header/reducer';
import Group_Favourite_Prompt_Category from './Group_Favourite_Prompt_Category';
import Multi_Line_chart from './Multi_Line_charts';
import { color } from 'echarts';
import classnames from "classnames";
import Gd_User_List from './Gd_User_List';
import Gd_User_Log from './Gd_User_Log';
import Add_User_To_Group_Modal from '../../Components/Common/CustomModal/Add_User_To_Group_Modal';
import { useSearchParams } from 'react-router-dom';

const Group_Name_Dashbord = () => {
    const [month_wise_token, setmonth_wise_token] = useState([])
    const [monthly_record, setmonthly_record] = useState(12)
    const [graph_date_range, setgraph_date_range] = useState('')
    const DB_List = useSelector((state)=> state.Select_DB_Modal.DB_List.connection)                                                                                                                                      
    // const { DB_List } = useSelector((state)=> state.Select_DB_Modal)
    const { Favorite_Prompt_Category , loading } = useSelector((state)=> state.Favourite_Prompt)
    const { state } = useLocation();
    const [group_id, setgroup_id] = useState()
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
 useEffect(() => {
    console.log(searchParams.get("group_id"), "Group ID")
    if(searchParams.get("group_id") !== null){
        setgroup_id(searchParams.get("group_id"))
        localStorage.setItem('group_id' ,searchParams.get("group_id"))
    }

    if(localStorage.getItem('group_id')){
        setgroup_id(localStorage.getItem('group_id'))
    }
    
 }, [])
 
    

    const group_owner = useSelector((state)=>state.GroupOwner)
    const { current_plan_details } = useSelector((state)=> state.Plans)


    useEffect(() => {


    dispatch(group_owner_details({ group_id:searchParams.get("group_id") }))
  //   dispatch(fetch_group_token_usages({ group_id:group_id }))
    dispatch(GET_DB_Connection({group_id:searchParams.get("group_id") }))
  dispatch(Get_Favourite_Prompt_Category({ group_id:searchParams.get("group_id") }))

             
    }, [searchParams.get("group_id")])




    


    const onClick_Leave_Group = async ()=>{
          dispatch(open_confirm_modal("Are You Sure You want to Leave this Group."))
          const decision = await waitForDecision()
          if(decision){
            dispatch(leave_group(group_owner.Group_Details.Group_ID,navigate))
          }

          dispatch(close_confirm_modal())
    }

    useEffect(()=>{
        dispatch(set_bread_crum({ title:"Group Dashboard"  , pageTitle:"Dashboard"  }))
   
        return ()=>{
        dispatch(set_bread_crum({ title:""  , pageTitle:""  }))
           
        }
      },[])


      useEffect(() => {
        if(!graph_date_range[1] && graph_date_range[0] )
        {
            return
        }
        getTokenUsedMonthwise({ group_id:searchParams.get('group_id') , monthly_record , start_date:graph_date_range[0] , end_date:graph_date_range[1] }).then((token) =>{
          
            
            setmonth_wise_token(token.result)
    
          }).catch((error)=>{
            console.log(error);
            
          })
    }, [setmonthly_record, monthly_record , graph_date_range])
    
     // Card Header Tabs
        const [cardHeaderTab, setcardHeaderTab] = useState("1");
        const cardHeaderToggle = (tab) => {
            if (cardHeaderTab !== tab) {
                setcardHeaderTab(tab);
            }
        };
  return (
    <>
    <React.Fragment>
        <div className="page-content pt-60">
        <Container fluid>
            {/* <BreadCrumb title="Group Dashboard" pageTitle="Dashboard" />     */}
            <Row className='head_name'>
                <Col lg={12}>
                <div className='on_line m-mt-10'>
                    <div>
                       <h2>{group_owner.Group_Details.Group_Name} </h2>
                       <span><Update_Group_Details/></span>
                       <span class="rounded-pill badge border border-secondary text-secondary">{group_owner.Group_Details.User_Role}</span>
                    </div>
                    {group_owner.Group_Details.User_Role !== 'Super User'&&<div className='leave-group'>
                         <Button onClick={onClick_Leave_Group}  color="danger" outline > Leave Group</Button>
                    </div>}
                </div>
                </Col>
                
            </Row>   
                                <div className="card-header align-items-center d-flex mt-3">                                    
                                    <div className="flex-shrink-0 ms-2">

                                        <Nav tabs className="nav justify-content-start nav-tabs-custom rounded card-header-tabs border-bottom-0">
                                            <NavItem>
                                                <NavLink style={{ cursor: "pointer" }} className={classnames({ active: cardHeaderTab === "1", })} onClick={() => { cardHeaderToggle("1"); }} >
                                                    Summary
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink style={{ cursor: "pointer" }} className={classnames({ active: cardHeaderTab === "2", })} onClick={() => { cardHeaderToggle("2"); }} >
                                                    User
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink style={{ cursor: "pointer" }} className={classnames({ active: cardHeaderTab === "3", })} onClick={() => { cardHeaderToggle("3"); }} >
                                                    User Log
                                                </NavLink>
                                            </NavItem>
                                        </Nav>

                                    </div>
                                </div>
                                    <TabContent activeTab={cardHeaderTab} className="text-muted">
                                        <TabPane tabId="1" id="summary">
                                            <Row>
                                              <Col lg={12}>
                                                    <Row>
                                                        <Col md={12}>
                                                            <div className='group_desc mb-3 mt-3'>
                                                                <Card className='no_border'>
                                                                    <CardBody>
                                                                        <div className="d-flex align-items-center">
                                                                            <div className="flex-grow-1">
                                                                                <h5 className="card-title mb-1">No. of bots</h5>
                                                                            </div>
                                                                            <div className="float-end flex-shrink-0">
                                                                                <img src={Bot} alt="" className="avatar-sm rounded-circle" />
                                                                            </div>                                        
                                                                        </div>
                                                                    </CardBody>
                                                                    <div className="card-footer pbt_0">
                                                                        <h3><b>{group_owner.Group_Bots.length}</b></h3>
                                                                    </div>                                
                                                                </Card>
                                                                <Card className='no_border'>
                                                                    <CardBody>
                                                                        <div className="d-flex align-items-center">
                                                                            <div className="flex-grow-1">
                                                                                <h5 className="card-title mb-1">Number of Users in this group</h5>
                                                                            </div>
                                                                            <div className="float-end flex-shrink-0">
                                                                                <img src={User} alt="" className="avatar-sm rounded-circle" />
                                                                            </div>                                        
                                                                        </div>
                                                                    </CardBody>
                                                                    <div className="card-footer pbt_0">
                                                                        <h3><b>{group_owner.Group_Users.length}</b></h3>
                                                                    </div>
                                                                </Card>
                                                                {group_owner?.Group_Details?.User_Role !== 'General User' && <>
                                                            <Token_Balane expires={current_plan_details.ValidTill} TokenAllowed={group_owner.Group_Details.Token_Allowed} TokenRemaining={group_owner.Group_Details.Token_Balance } />
                                                            </>}
                                                            </div>
                                                        </Col>
                                                        {/* <Col md={4}>
                                                            <Card className='no_border'>
                                                                <CardBody>
                                                                    <div className="d-flex mb-4 align-items-center">
                                                                        <div className="flex-grow-1">
                                                                            <h5 className="card-title mb-1">No. of bots</h5>
                                                                        </div>
                                                                        <div className="float-end flex-shrink-0">
                                                                            <img src={Bot} alt="" className="avatar-sm rounded-circle" />
                                                                        </div>                                        
                                                                    </div>
                                                                </CardBody>
                                                                <div className="card-footer pbt_0">
                                                                    <h3><b>{group_owner.Group_Bots.length}</b></h3>
                                                                </div>                                
                                                            </Card>
                                                        </Col>
                                                        <Col md={4}>
                                                            <Card className='no_border'>
                                                                <CardBody>
                                                                    <div className="d-flex mb-4 align-items-center">
                                                                        <div className="flex-grow-1">
                                                                            <h5 className="card-title mb-1">Number of Users in this group</h5>
                                                                        </div>
                                                                        <div className="float-end flex-shrink-0">
                                                                            <img src={User} alt="" className="avatar-sm rounded-circle" />
                                                                        </div>                                        
                                                                    </div>
                                                                </CardBody>
                                                                <div className="card-footer pbt_0">
                                                                    <h3><b>{group_owner.Group_Users.length}</b></h3>
                                                                </div>
                                                            </Card>
                                                        </Col>
                                                        <Col md={4}>
                                                        {group_owner?.Group_Details?.User_Role !== 'General User' && <div className='group_token_bal'>
                                                        <Token_Balane expires={current_plan_details.ValidTill} TokenAllowed={group_owner.Group_Details.Token_Allowed} TokenRemaining={group_owner.Group_Details.Token_Balance } />
                                                        </div>}
                                                        </Col> */}
                                                    </Row>
                                                    <Row>
                                                        {group_owner.loading
                                                        ?
                                                        <Loader/>:<><Col lg={4}>
                                                                    <Bot_In_Group group_id={searchParams.get("group_id")} />
                                                                </Col>
                                                                {/* <Col lg={4}><Users_In_Group  /></Col> */}
                                                                <Col lg={4}>
                                                                    {loading ? <Loader/> :<Card className='no_border'>
                                                                        <CardBody>
                                                                            <h6 class="card-title mb-0">Prompt Category List</h6>
                                                                            <div className='pcl_list_wrap'>
                                                                            <ListGroup className='no_border ht-400'>
                                                                                {
                                                                                    Favorite_Prompt_Category.map((category, index) => {
                                                                                        return <Group_Favourite_Prompt_Category category={category} key={index} group_id={searchParams.get("group_id")} />
                                                                                    })
                                                                                }
                                                                                
                                                                            </ListGroup>
                                                                            </div>
                                                                        </CardBody>
                                                                    </Card>}
                                                                </Col>
                                                                {group_owner?.Group_Details?.User_Role !== 'General User' &&<Col lg={4}>
                                                                    <Database_In_Group DB_List={DB_List} />
                                                                </Col>}
                                                                </>
                                                                }
                                                    </Row>
                                                </Col>
                                                <Col lg={12}>
                                                        
                                                        {/* {group_owner.Group_Details.User_Role === 'Super User'&&<>
                                                    
                                                        <Token_Usage tokens={group_owner.Token_Used_By_Group} token_allowed={group_owner.Group_Details.Token_Allowed} percentage_difference={group_owner.Group_Details.Token_Per_Difference}  /></>
                                                        
                                                        } */}
                                                        {/* <Upgrade_Plans /> */}
                                                </Col>
                                                <Col md={12}>
                                                {group_owner?.Group_Details?.User_Role !== 'General User' &&<Card>
                                                    <CardBody>
                                                        
                                                            {/* <Token_Usage_Chart setmonthly_record={setmonthly_record} month_count={monthly_record} token_usages={month_wise_token}  dataColor={'rgb(255 236 0)'} bgColor={'white'} /> */}
                                                            <Multi_Line_chart graph_date_range={graph_date_range} setgraph_date_range={setgraph_date_range}  month_wise_token={month_wise_token} setmonth_wise_token={setmonth_wise_token} dataColors='["--vz-primary", "--vz-danger", "--vz-success"]' />
                                                    </CardBody>
                                                </Card>}
                                            
                                                </Col>
                                                {/* <Col md={4}>
                                                    {loading ? <Loader/> :<Card className='no_border'>
                                                        <CardBody>
                                                            <h6 class="card-title mb-0">Prompt Category List</h6>
                                                            <div className='pcl_list_wrap'>
                                                            <ListGroup className='no_border ht-400'>
                                                                {
                                                                    Favorite_Prompt_Category.map((category, index) => {
                                                                        return <Group_Favourite_Prompt_Category category={category} key={index} group_id={group_id} />
                                                                    })
                                                                }
                                                                
                                                            </ListGroup>
                                                            </div>
                                                        </CardBody>
                                                    </Card>}
                                                </Col> */}
                                                </Row>
                                        </TabPane>

                                        <TabPane tabId="2" id="user_details">
                                           {group_owner?.Group_Details?.User_Role !== 'General User' && <div className='mt-3 mb-3' style={{textAlign:'right'}}> <Add_User_To_Group_Modal/> </div>}
                                           <Gd_User_List group_id={searchParams.get("group_id")} />

                                        </TabPane>

                                        <TabPane tabId="3" id="user_log">
                                           
                                            <Gd_User_Log group_id={searchParams.get("group_id")} />
                                        </TabPane>
                                    </TabContent>
                               
        </Container>
      </div>
    </React.Fragment>
     
    </>
  )
}

export default Group_Name_Dashbord
